import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
} from '@mui/material';
import {
  Casino,
  ShoppingCart,
} from '@mui/icons-material';
import { ProcessedTicketData } from '../../types/processedTicket';

interface ActionButtonsProps {
  packs: ProcessedTicketData[];
  lotteryPayoutLoading: boolean;
  scratcherPayoutLoading: boolean;
  lottoSaleLoading: boolean;
  onLotteryPayout: (type: 'lotto' | 'scratchers') => void;
  onLottoSale: () => void;
  compact?: boolean;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  packs,
  lotteryPayoutLoading,
  scratcherPayoutLoading,
  lottoSaleLoading,
  onLotteryPayout,
  onLottoSale,
  compact = false,
}) => {
  const hasPacks = packs && packs.length > 0;
  const buttonWidth = compact ? '170px' : '200px';
  const buttonHeight = compact ? '42px' : '46px';

  return (
    <Box display="flex" flexDirection="row" gap="12px">
      <Button
        variant="contained"
        size={compact ? 'medium' : 'large'}
        onClick={() => onLotteryPayout('lotto')}
        disabled={lotteryPayoutLoading || !hasPacks}
        startIcon={lotteryPayoutLoading ? <CircularProgress size={20} sx={{ color: '#ffffff' }} /> : <Casino />}
        sx={{
          width: buttonWidth,
          height: buttonHeight,
          borderRadius: '8px',
          background: '#2C6CA0',
          color: '#ffffff',
          fontWeight: 600,
          cursor: lotteryPayoutLoading ? 'not-allowed' : 'pointer',
          '&:hover': {
            background: '#2C6CA0',
          },
          '&:disabled': {
            cursor: 'not-allowed !important',
          },
        }}
      >
        Payout Lotto
      </Button>
      <Button
        variant="contained"
        size={compact ? 'medium' : 'large'}
        onClick={onLottoSale}
        disabled={lottoSaleLoading}
        startIcon={lottoSaleLoading ? <CircularProgress size={20} sx={{ color: '#ffffff' }} /> : <ShoppingCart />}
        sx={{
          width: buttonWidth,
          height: buttonHeight,
          borderRadius: '8px',
          background: '#2C6CA0',
          color: '#ffffff',
          fontWeight: 600,
          cursor: lotteryPayoutLoading ? 'not-allowed' : 'pointer',
          '&:hover': {
            background: '#2C6CA0',
          },
          '&:disabled': {
            cursor: 'not-allowed !important',
          },
        }}
      >
        Sale Lotto
      </Button>
      {/* <Button
        onClick={() => onLotteryPayout('scratchers')}
        disabled={scratcherPayoutLoading || !hasPacks}
        startIcon={scratcherPayoutLoading ? <CircularProgress size={20} sx={{ color: '#ffffff' }} /> : <Receipt />}
        sx={{
          background: scratcherPayoutLoading
            ? '#2C6CA0'
            : '#2C6CA0',
          color: '#ffffff',
          fontWeight: 600,
          cursor: scratcherPayoutLoading ? 'not-allowed' : 'pointer',
          '&:hover': {
            background: scratcherPayoutLoading
              ? '#2C6CA0'
              : '#2C6CA0',
          },
          '&:disabled': {
            color: '#ffffff',
            fontWeight: 600,
            cursor: 'not-allowed !important',
          },
        }}
      >
         Payout Scratchers
      </Button> */}
    </Box>
  );
}; 
